<template>
  <footer class="footer mt-6 py-6" :class="$style.showTopSeparator">
    <div class="container">
      <div class="columns">
        <div class="column is-3 is-offset-2">
          <h2>
            <strong>Empresa</strong>
          </h2>
          <ul>
            <li>
              <router-link :to="{ name: 'home' }">Nosotros</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'home' }">Clientes</router-link>
            </li>
          </ul>
        </div>
        <div class="column is-3">
          <h2>
            <strong>Plataforma</strong>
          </h2>
          <ul>
            <li>
              <router-link :to="{ name: 'features' }">Producto</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'integrations' }"
                >Integraciones</router-link
              >
            </li>
          </ul>
        </div>
        <div class="column is-4">
          <h2>
            <strong>Contacto</strong>
          </h2>
          <ul>
            <li>
              <router-link :to="{ name: 'contact' }">Contactanos</router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="content mt-6 has-text-centered">
      <div class="control level-item">
        <a href="#">
          <div class="tags has-addons">
            <span class="tag is-dark"
              >© Datalized 2020. Todos los derechos reservados</span
            >
            <!-- <span class="tag is-info">MIT license</span> -->
          </div>
        </a>
      </div>
      <div class="control level-item" :class="$style.privacy">
        <router-link :to="{ name: 'privacy' }">
          politica de privacidad
        </router-link>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style lang="scss" module>
.showTopSeparator {
  border-top: 1px solid #d0d0d0;
}
.privacy {
  margin-top: 1rem;
  font-size: smaller;
}
</style>
